import { useEffect, useState } from 'react';

/**
 * Suscripcion a una media query desde React.
 *
 * El shell necesita conocer el ancho real para decidir si el sidebar es una
 * columna o un panel deslizante. Resolverlo solo con clases de CSS dejaria el
 * estado de accesibilidad incoherente: el atrapado de foco y `aria-hidden`
 * dependen de si el panel esta de verdad en pantalla, no de como se pinta.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = (event: MediaQueryListEvent): void => {
      setMatches(event.matches);
    };

    setMatches(list.matches);
    list.addEventListener('change', update);

    return () => {
      list.removeEventListener('change', update);
    };
  }, [query]);

  return matches;
}

/** Punto en el que el sidebar deja de ser panel deslizante y pasa a columna. */
export const DESKTOP_QUERY = '(min-width: 768px)';

/** A partir de aqui hay sitio para el sidebar expandido sin comprimir la tabla. */
export const WIDE_QUERY = '(min-width: 1280px)';
